import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {FileTextIcon} from 'shells/icon/svg/file-text-icon';
// @ts-expect-error - imported from .js/.jsx file
import {SiteGlobeIcon} from 'shells/icon/svg/site-globe-icon';
import {Body} from 'shells/typography/body';

import type {DocumentSourceTypeEnum} from 'nutshell-graphql-types';

type Props = {
    sourceType: DocumentSourceTypeEnum;
};

export const EmptyState = (props: Props) => {
    const Icon = props.sourceType === 'WEB_PAGE' ? SiteGlobeIcon : FileTextIcon;
    const title = `You have not added any ${
        props.sourceType === 'WEB_PAGE' ? 'web pages' : 'documents'
    } yet.`;

    return (
        <div className='flex flex-dir-col gap-4 py-64 justify-center align-center'>
            <Icon size={16} fill={colors.greyXlt} />
            <Body size='small' color='light'>
                {title}
            </Body>
        </div>
    );
};
